<template>
    <div class="inventory">
        <b-card no-body class="p-3">
            <b-tabs card v-model="tabIndex" @activate-tab="tabActivated">
                <b-tab :title="$translate('data')" class="p-0" active>
                    <b-card no-body class="mt-3">
                        <b-card-header
                            class="prepare-data d-flex justify-content-between"
                        >
                            <span class="my-auto px-2">{{
                                $translate('prepare_data')
                            }}</span>
                            <b-button
                                class="float-right btn-fw"
                                @click="updateConfiguration"
                                variant="info"
                            >
                                <b-icon
                                    v-if="loading"
                                    icon="arrow-clockwise"
                                    class="fa-spin"
                                    animation="spin"
                                ></b-icon>
                                <span v-else>{{
                                    $translate('save_settings')
                                }}</span>
                            </b-button>
                        </b-card-header>
                        <b-card-body class="p-0 mt-3">
                            <b-card class="form-control p-0">
                                <b-row class="mt-2 gx-2">
                                    <b-col
                                        cols="12"
                                        md="3"
                                        class="mb-2 mb-md-0 pt-0 pt-md-2"
                                        >{{ $translate('site') }}</b-col
                                    >

                                    <b-col class="dd">
                                        <b-form-select
                                            class="form-control"
                                            id="input-location"
                                            v-model="formData.location_id"
                                            :options="locations"
                                            value-field="id"
                                            text-field="name"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                >
                                                    {{
                                                        $translate(
                                                            'select_warehouse'
                                                        )
                                                    }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>

                                    <b-col class="dd">
                                        <b-form-select
                                            class="form-control"
                                            id="input-section"
                                            v-model="formData.section_id"
                                            :options="sections"
                                            value-field="id"
                                            text-field="name"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                >
                                                    {{
                                                        $translate(
                                                            'select_section'
                                                        )
                                                    }}
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2 gx-2">
                                    <b-col
                                        cols="12"
                                        md="3"
                                        class="mb-2 mb-md-0 pt-0 pt-md-2"
                                        >{{
                                            $translate('from_date_time')
                                        }}</b-col
                                    >
                                    <b-col class="mb-2 mb-md-0">
                                        <b-form-input
                                            id="input-date"
                                            v-model="formData.startDate"
                                            placeholder="Enter Date"
                                            type="date"
                                        ></b-form-input>
                                    </b-col>
                                    <b-col>
                                        <b-form-input
                                            id="input-startTime"
                                            v-model="formData.startTime"
                                            placeholder="Start Time"
                                            type="time"
                                        ></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="mt-2 gx-2">
                                    <b-col
                                        cols="12"
                                        md="3"
                                        class="mb-2 mb-md-0 pt-0 pt-md-2"
                                        >{{ $translate('to_date_time') }}</b-col
                                    >
                                    <b-col class="mb-2 mb-md-0">
                                        <b-form-input
                                            id="input-date"
                                            v-model="formData.endDate"
                                            type="date"
                                        ></b-form-input>
                                    </b-col>
                                    <b-col>
                                        <b-form-input
                                            id="input-endTime"
                                            v-model="formData.endTime"
                                            type="time"
                                        ></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-card>

                            <b-row class="filter-form p-0 pt-2 g-2">
                                <b-col cols="12" md="6">
                                    <b-card
                                        :title="$translate('bundled_items')"
                                        class="form-control p-2"
                                    >
                                        <div class="my-2">
                                            <master-item-type-ahead
                                                key="majorItems"
                                                v-model="major_item_id"
                                                :is-bundled-only="true"
                                                :is-product-only="true"
                                                :item-type-id.sync="
                                                    order_item_type_id
                                                "
                                                :parent-searched-text.sync="
                                                    searchText
                                                "
                                            ></master-item-type-ahead>
                                        </div>

                                        <b-table
                                            :fields="fields"
                                            striped
                                            hover
                                            responsive
                                            :items="bundledItems"
                                            :busy="loading"
                                        >
                                            <template #cell(id)="{ value }">
                                                <b-button
                                                    variant="pink-button"
                                                    @click="
                                                        bundledItems.splice(
                                                            bundledItems.findIndex(
                                                                x =>
                                                                    x.id ==
                                                                    value
                                                            ),
                                                            1
                                                        )
                                                    "
                                                >
                                                    <img
                                                        src="@/assets/images/icon/delete.svg"
                                                    />
                                                </b-button>
                                            </template>
                                            <template #table-busy>
                                                <div
                                                    class="text-center text-danger my-2"
                                                >
                                                    <b-spinner
                                                        class="align-middle"
                                                    ></b-spinner>
                                                    <strong>{{
                                                        $translate('loading')
                                                    }}</strong>
                                                </div>
                                            </template>
                                        </b-table>
                                    </b-card>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-card
                                        :title="$translate('secondary_items')"
                                        class="form-control p-2"
                                    >
                                        <div class="my-2">
                                            <master-item-type-ahead
                                                key="minorItems"
                                                v-model="minor_item_id"
                                                :is-product-only="true"
                                                :item-type-id.sync="
                                                    order_item_type_id
                                                "
                                                :parent-searched-text.sync="
                                                    searchText2
                                                "
                                            ></master-item-type-ahead>
                                        </div>
                                        <b-table
                                            :fields="fields"
                                            hover
                                            responsive
                                            :items="minorItems"
                                            :busy="loading"
                                        >
                                            <template #cell(id)="{ value }">
                                                <b-button
                                                    variant="pink-button"
                                                    @click="
                                                        minorItems.splice(
                                                            minorItems.findIndex(
                                                                x =>
                                                                    x.id ==
                                                                    value
                                                            ),
                                                            1
                                                        )
                                                    "
                                                >
                                                    <img
                                                        src="@/assets/images/icon/delete.svg"
                                                    />
                                                </b-button>
                                            </template>
                                            <template #table-busy>
                                                <div
                                                    class="text-center text-danger my-2"
                                                >
                                                    <b-spinner
                                                        class="align-middle"
                                                    ></b-spinner>
                                                    <strong>{{
                                                        $translate('loading')
                                                    }}</strong>
                                                </div>
                                            </template>
                                        </b-table>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </b-tab>
                <b-tab :title="$translate('customisation')" class="p-0"
                    ><b-card-text>
                        <usage-settings
                            :loading="loading"
                            :headings="headings"
                            :usage-settings-data="settingsData"
                            :usage-switches="switches"
                            @update-settings="evt => (settingsData = evt)"
                            @update-switches="evt => (switches = evt)"
                            @update-configuration="updateConfiguration"
                        /> </b-card-text
                ></b-tab>
                <b-tab :title="$translate('report')" class="p-0">
                    <b-card-body class="p-0 mt-2">
                        <display-usage
                            v-if="tabIndex == 2"
                            :vendors="vendors"
                            :minor-items="minorItems"
                            :opening-time="startDatetime"
                            :closing-time="endDateTime"
                            :headings="headings"
                            :settings="indexSettings"
                            :parse-item="parseItem"
                            :section-id="formData.section_id"
                            :order-types="orderTypes"
                        />
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'
import DisplayUsage from './DisplayUsage.vue'
import UsageSettings from './UsageSettings.vue'
import popupMixins from '@/mixins/popupMixins'
import settingsMixins from '@/mixins/settingsMixins'

const dt = new Date()

const usageDate = `${dt.getFullYear()}-${
    (dt.getMonth() < 9 ? '0' : '') + (dt.getMonth() + 1)
}-${dt.getDate()}`
const startTime = '08:00:00'
const endTime = '17:00:00'
const settingsKeyName = 'inventoryUsageKey'
export default {
    components: { MasterItemTypeAhead, DisplayUsage, UsageSettings },
    mixins: [popupMixins, settingsMixins],
    data() {
        return {
            tabIndex: 0,
            order_item_type_id: null,
            searchText: null,
            searchText2: null,
            indexSettings: {},
            settingsKeyName,

            formData: {
                location_id: null,
                section_id: null,
                startDate: usageDate,
                endDate: usageDate,
                startTime,
                endTime,
            },
            loading: false,
            major_item_id: null,
            minor_item_id: null,
            bundledItems: [],
            minorItems: [],
            //////////////usage
            settingsData: {},
            switches: {},
        }
    },

    computed: {
        fields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: this.$translate('vendor'),
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) => item.selling_price,
                },
            ]
        },
        headings() {
            return [
                'opening_bundled_count',
                'opening_unbundled_sub_product_count',
                'purchases_principal_product',
                'purchases_sub_product',
                'sales_principal_product',
                'sales_sub_product',
                'returned_unbundled_sub_product_count',
                'closing_bundled_count',
                'closing_unbundled_sub_product_count',
                'total_unbundled_sub_product_count',
            ]
        },

        vendors() {
            const {
                formData: { section_id: sectionId },
                bundledItems,
                $set,
                parseItem,
            } = this

            if (!sectionId) return []

            bundledItems.sort((a, b) => a.size - b.size)
            const _vendors = bundledItems
                .filter(x => !!(x.vendor && x.vendor.id))
                .reduce((_vendors, m_item) => {
                    const newItem = parseItem(m_item, sectionId)
                    $set(
                        newItem,
                        'container',
                        parseItem(newItem.container, sectionId)
                    )
                    let vIdx = _vendors.findIndex(v => v.id == m_item.vendor.id)
                    if (vIdx < 0) {
                        const vendor = { ...m_item.vendor, items: [] }
                        _vendors = [..._vendors, vendor]
                        vIdx = _vendors.length - 1
                    }
                    _vendors[vIdx].items.push(newItem)
                    return _vendors
                }, [])

            _vendors.sort((a, b) => a.name.localeCompare(b.name))

            return _vendors
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            )
        },
        sections() {
            const { location_id } = this.formData
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },

        startDatetime() {
            const { startTime, startDate } = this.formData
            return this.convertTime(startDate, startTime)
        },
        endDateTime() {
            const { endTime, endDate } = this.formData
            return this.convertTime(endDate, endTime)
        },
        orderTypes() {
            const types = this.$store.state.orderType.items
            console.log('order types', types)
            return types
        },
        /////from usage
        bundledList() {
            return this.bundledItems.map(x => x.id)
        },
        minorList() {
            return this.minorItems.map(x => x.id)
        },
    },

    watch: {
        major_item_id: function (id) {
            if (id) {
                this.major_item_id = null
                this.getMasterItem(id, 'bundledItems')
            }
        },
        minor_item_id: function (id) {
            if (id) {
                this.minor_item_id = null
                this.getMasterItem(id, 'minorItems')
            }
        },
        sections: {
            handler: function (val) {
                if (val && val.length) {
                    this.$set(this.formData, 'section_id', val[0].id)
                }
            },
            deep: true,
        },
        ///////////////////previously usage
        configurationSettings: {
            handler: function (val) {
                this.setSettingsData(val)
            },
            deep: true,
        },
    },

    created() {
        console.log('timezone', new Date().getTimezoneOffset())
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('users/fetchAll')
    },
    mounted() {
        this.setSettingsData(this.configurationSettings)
    },

    methods: {
        tabActivated(newTabIndex, oldTabIndex, event) {
            if (newTabIndex == 2) {
                try {
                    const {
                        startDatetime,
                        endDateTime,
                        bundledItems,
                        formData: { section_id },
                    } = this
                    if (bundledItems.length == 0)
                        throw new Error(this.$translate('bundled_items_error'))
                    if (!section_id)
                        throw new Error(
                            this.$translate('location_not_selected')
                        )
                    if (startDatetime >= endDateTime)
                        throw new Error(this.$translate('start_end_time_error'))
                } catch (error) {
                    event.preventDefault()
                    this.doToast(
                        this.$translate('error'),
                        error.message,
                        'danger'
                    )
                }
            }
        },

        parseItem(item, sectionId) {
            const newItem = { ...item }

            let newSection = {}
            if (newItem.sections) {
                newSection =
                    item.sections.find(
                        x => x.location_section_id == sectionId
                    ) || {}
            }

            newItem.section = { ...newSection }
            this.$delete(newItem, 'sections')

            newItem.section.transactions = newItem.section.transactions || []

            newItem.section.transactions.forEach(x => {
                x.signature_data = null
                return x
            })
            return newItem
        },

        async updateSettings(evt) {
            this.indexSettings = { ...evt }
            let { formData, bundledList, minorList } = { ...evt }
            formData = formData || {}
            bundledList = bundledList || []
            minorList = minorList || []

            for (const key in formData) {
                this.$set(this.formData, key, formData[key])
            }

            await Promise.all(
                bundledList.map(id => this.getMasterItem(id, 'bundledItems'))
            )

            await Promise.all(
                minorList.map(id => this.getMasterItem(id, 'minorItems'))
            )

            this.$delete(this.indexSettings, 'formData')
            this.$delete(this.indexSettings, 'bundledList')
            this.$delete(this.indexSettings, 'minorList')
        },

        convertTime(datePart, timePart) {
            if (!timePart) return null
            if (!datePart) return null
            let [year, month, day] = datePart.split('-')
            let [hour, minute] = timePart.split(':')
            const unixTime = new Date(
                parseInt(year),
                parseInt(month) - 1,
                parseInt(day),
                parseInt(hour),
                parseInt(minute)
            ).getTime()
            return unixTime
        },

        async getMasterItem(id, type) {
            try {
                this.loading = true
                const item = await this.$store.dispatch(
                    'masterItem/fetchByIdFunction',
                    id
                )
                if (
                    this[type].length == 0 ||
                    !this[type].some(x => x.id == id)
                ) {
                    if (type === 'bundledItems' && item.container) {
                        const bundledItem = await this.$store.dispatch(
                            'masterItem/fetchByIdFunction',
                            item.container_id
                        )

                        item.container = bundledItem
                    }

                    const idx = this[type].findIndex(x => x.id == item.id)
                    this.$set(
                        this[type],
                        idx >= 0 ? idx : this[type].length,
                        item
                    )
                }
                this.searchText = null
                this.searchText2 = null
            } catch (err) {
                console.error('getMasterItem errior', err)
            } finally {
                this.loading = false
            }
        },
        /////////////////////////////previously usage
        setSettingsData(_configurationSettings) {
            const otherHeadings = [
                'bundled_product_type',
                'bundled_product',
                'sub_product_totals_by_size',
                'secondary_items_closing_balances',
            ]
            _configurationSettings = _configurationSettings || {}

            for (const key of [...this.headings, ...otherHeadings]) {
                const { title, required } = _configurationSettings[key] || {}
                this.$set(this.settingsData, key, title)
                this.$set(this.switches, key, !!required)
            }

            this.updateSettings(_configurationSettings)
        },

        async updateConfiguration() {
            try {
                this.loading = true
                ////previously from usage
                const { settingsData, switches } = this
                const _data = {}

                for (const key in settingsData) {
                    const title = settingsData[key]
                    const required = !!switches[key]
                    this.$set(_data, key, { title, required })
                }

                this.$set(_data, 'bundledList', this.bundledList)
                this.$set(_data, 'minorList', this.minorList)
                this.$set(_data, 'formData', this.formData)

                const text_value = JSON.stringify(_data)
                const bool_value = false
                const key = this.settingsKey

                console.log('update data:', {
                    key,
                    text_value,
                    bool_value,
                })

                await this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })

                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('settings')} ${this.$translate(
                        'update_alert'
                    )}`,
                    'success'
                )
            } catch (err) {
                console.error(err.message)
                this.doToast(
                    this.$translate('error'),
                    `${err.message}`,
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
